import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from '../lib/cn';
/**
 * A shimmering block matching the geometry of what is loading.
 *
 * The handoff is explicit: "skeleton blocks matching card geometry (never
 * spinners on content areas)". A spinner says *something is happening*; a
 * skeleton says *what is about to be here*, which on a content app is the
 * difference between waiting and being told to wait.
 */
export function Skeleton({ className }) {
    return _jsx("div", { "aria-hidden": true, className: cn('lb-shimmer rounded-[var(--r-sm)]', className) });
}
/**
 * The loading form of a content card. Kept beside ContentCard so the two move
 * together — a skeleton that stops matching its card is worse than none, because
 * it promises a layout that then jumps.
 */
export function ContentCardSkeleton() {
    return (_jsxs("div", { className: "rounded-[var(--r-lg)] border border-border bg-surface p-card", children: [_jsx(Skeleton, { className: "mb-4 aspect-[16/10] w-full rounded-[var(--r)]" }), _jsx(Skeleton, { className: "mb-2 h-3 w-20" }), _jsx(Skeleton, { className: "mb-3 h-4 w-3/4" }), _jsx(Skeleton, { className: "h-3 w-1/2" })] }));
}
/** `count` skeletons, for a rail or a grid that is about to hold several. */
export function SkeletonList({ count = 3 }) {
    return (_jsx(_Fragment, { children: Array.from({ length: count }, (_, i) => (_jsx(ContentCardSkeleton, {}, i))) }));
}
//# sourceMappingURL=skeleton.js.map